<template>
  <div id="vrijwilliger" class="page">
      <ContentHeader header-title="Word vrijwilliger bij RTVP!"/>
      <p>
          Op een professionele werkvloer kunnen altijd wat extra handjes gebruikt worden. We zijn daarom ook op zoek naar enthousiaste, 
          leergierige en gemotiveerde vrijwilligers die onze radio en televisiezender willen komen versterken.<br>
          <br>
          Wij zoeken vrijwilligers voor de volgende functies:<br>
          <br>
      </p>
      
      <h3>Cameraman (M/V)</h3>
      <p>
          Je hebt affiniteit met camerawerk en altijd op zoek naar het perfecte plaatje tijdens producties.
          Enige ervaring met camera’s in ENG en/of een meercamera-setting is een pre.
      </p>

      <h3>Editor (M/V)</h3>
      <p>
          Je hebt een goede visie op montages van videoproducties waarbij het eindplaatje past binnen het profiel van het programma.
          Ervaring met het programma: Adobe Premiere CC is een pre.
      </p>

      <h3>Redactie medewerker (M/V)</h3>
      <p>
          Je bent sterk in het zoeken van items en/of het bedenken van nieuwe items/programma’s.
          Je bent een teamspeler en goed in het organiseren en plannen van werkzaamheden.
      </p>

      <h3>Producer radio (M/V)</h3>
      <p>
          Jij weet hoe je een radioprogramma interessant maakt, en je kunt goed communiceren waardoor je samen met de programmamaker een radioshow tot een succes maakt. 
          Je komt met leuke ideeën en bent creatief in het verzinnen van content voor het populairste radiostation van Parkstad!<br>
          <br>
          Wij bieden jou een gezellige en professionele werkomgeving waarin voldoende ruimte is om creatief te kunnen functioneren.
          Enthousiast geworden? Stuur dan jouw motivatie en eventuele portfolio naar <span class="orange">redactie@rtvparkstad.nl</span> en wie weet word jij onze nieuwe collega!
      </p>
  </div>
</template>

<script>
import ContentHeader from "@/components/ContentHeader.vue";

export default {
  name: "Vrijwilliger",
  components: {
    ContentHeader
  },
}
</script>

<style lang="scss" scoped>
#vrijwilliger {
  margin: auto;
  max-width: 768px;

 h3 {
    font-family: "Lato";
    color: #ffae32;
    font-weight: bold;
    margin-bottom: 15px;  
    }

  p {
    font-family: "Lato";
    font-size: 14px;
    margin-bottom: 16px;

    .orange {
      color: #FF5000;
    }

  }
}

/* Smartphones (portrait and landscape) ----------- */

@media only screen and (min-device-width: 320px) and (max-device-width: 599px) {
    #vrijwilliger {
      margin: 16px 16px;
    }
}

/* Tablet (portrait) ----------- */

@media only screen and (min-device-width: 600px) and (max-device-width: 899px) {
    #vrijwilliger {
      margin: 16px 16px;
    }
}

/* Tablet (landscape) ----------- */

@media only screen and (min-device-width: 900px) and (max-device-width: 1199px)  {
    #vrijwilliger {
        margin: 16px 16px;
    }
}

// Desktop versions start here ------------------------------------------------------------------------------------------
/* Desktop ----------- */

@media only screen and (min-device-width: 1200px) and (max-device-width: 1799px)  {
    #vrijwilliger {
      margin-top: 160px;
      margin-bottom: 100px;
    }
}

/* Large desktop ----------- */

@media only screen and (min-device-width: 1800px)  {
    #vrijwilliger {
      margin-top: 160px;
      margin-bottom: 100px;
    }
}
</style>